/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getDeliveryStopsPod } from "api/services/shipment";
import { GetDeliveryStopsPodResponse } from "api/response";
import { shipmentQueryKeys } from "./shipmentQueryKeys";

export function useGetDeliveryStopsPod(
  id: string,
  options?: Omit<UseQueryOptions<GetDeliveryStopsPodResponse>, "queryKey" | "queryFn">,
) {
  return useQuery({
    queryKey: shipmentQueryKeys.deliveryStopsPod(id),
    queryFn: () => getDeliveryStopsPod(id).then((res) => res.data as GetDeliveryStopsPodResponse),
    ...options,
  });
}
